'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/.15.4.2@react-dom/index.js
// module id = 15
// module chunks = 0